const TRUNCATE_PX = 224;
const TRUNCATE_CLASSES = ['max-h-56', 'overflow-hidden'];

const initMultiContent = () => {
  document.querySelectorAll('[data-multi-content]').forEach((section) => {
    const buttons = section.querySelectorAll('[data-tab-btn]');
    const showMoreText = section.dataset.showMore;
    const showLessText = section.dataset.showLess;
    const collapseHandlers = new Map();

    const initTruncation = (panel) => {
      const body = panel.querySelector('[data-tab-body]');
      if (!body || body.dataset.truncateInit) return;
      body.dataset.truncateInit = 'true';
      if (body.scrollHeight <= TRUNCATE_PX) return;

      body.classList.add(...TRUNCATE_CLASSES, 'relative');

      const gradient = document.createElement('div');
      gradient.className = 'absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-white pointer-events-none';
      body.appendChild(gradient);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mt-4 text-sm underline font-medium hover:text-desert transition-colors self-start';

      const collapse = () => {
        body.classList.add(...TRUNCATE_CLASSES);
        gradient.classList.remove('hidden');
        btn.textContent = showMoreText;
        delete panel.dataset.expanded;
      };

      const expand = () => {
        body.classList.remove(...TRUNCATE_CLASSES);
        gradient.classList.add('hidden');
        btn.textContent = showLessText;
        panel.dataset.expanded = 'true';
      };

      btn.textContent = showMoreText;
      btn.addEventListener('click', () => panel.dataset.expanded ? collapse() : expand());
      panel.appendChild(btn);
      collapseHandlers.set(panel, collapse);
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tabBtn;
        buttons.forEach((b) => { b.removeAttribute('data-active'); b.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('data-active', '');
        btn.setAttribute('aria-selected', 'true');
        section.querySelectorAll('[data-tab-content]').forEach((el) => {
          const isLeaving = !el.classList.contains('hidden') && el.dataset.tabContent !== tab;
          if (isLeaving && el.dataset.expanded) collapseHandlers.get(el)?.();
          el.classList.toggle('hidden', el.dataset.tabContent !== tab);
          if (el.dataset.tabContent === tab && el.dataset.tabId?.includes('ingredient')) {
            initTruncation(el);
          }
        });
        section.querySelectorAll('[data-tab-image]').forEach((el) => el.classList.toggle('hidden', el.dataset.tabImage !== tab));
      });
    });

    requestAnimationFrame(() => {
      section.querySelectorAll('[data-tab-id*="ingredient"]:not(.hidden)').forEach(initTruncation);
    });
  });
};

export default initMultiContent;
